import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import {
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { TooltipHost, TooltipOverflowMode, DirectionalHint } from '@bingads-webui-react/fabric-control';
import { CouponTagNew } from '@bingads-webui-react/feature-adoption-coupon';
import { RecommendationOptimizationScoreTag } from '@bingads-webui-campaign-react/recommendation-os-tag';
import {
  Badge,
} from '@fluentui/react-components';

import { SummaryContextMenu } from './summary-context-menu';

export class SummaryHeader extends React.PureComponent {
  static propTypes = {
    iconClasses: PropTypes.string.isRequired,
    iconClassesVNext: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    scope: PropTypes.shape({
      levelAt: PropTypes.string,
    }),
    coupon: PropTypes.objectOf(PropTypes.any),
    optimizationScore: PropTypes.number,
    overallOptimizationScoreBar: PropTypes.shape({
      Gained: PropTypes.number,
      Dismissed: PropTypes.number,
      Available: PropTypes.number,
    }),
    isOptimizationScoreOn: PropTypes.bool,
    headerMenuItems: PropTypes.arrayOf(PropTypes.any),
    isFromDismissTab: PropTypes.bool,
    showAutoApply: PropTypes.bool,
    campaignAutoApplyStatus: PropTypes.shape({
      [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: PropTypes.string,
    }),
    inContextCard: PropTypes.bool,
    autoApplyToolTipText: PropTypes.string,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }),
    type: PropTypes.string.isRequired,
  };

  static defaultProps = {
    scope: {
      levelAt: null,
    },
    coupon: null,
    optimizationScore: null,
    overallOptimizationScoreBar: null,
    isOptimizationScoreOn: false,
    headerMenuItems: [],
    isFromDismissTab: false,
    campaignAutoApplyStatus: {},
    inContextCard: false,
    autoApplyToolTipText: '',
    newI18n: {
      getString: _.noop,
    },
    showAutoApply: false,
  };

  render() {
    const {
      i18n,
      iconClasses,
      iconClassesVNext,
      title,
      coupon,
      optimizationScore,
      overallOptimizationScoreBar,
      isOptimizationScoreOn,
      headerMenuItems,
      isFromDismissTab,
      inContextCard,
      autoApplyToolTipText,
      newI18n,
      showAutoApply,
      type,
    } = this.props;

    return (
      <div className="recommendation-summary-header">
        <div className={`summary-header-icon ${iconClasses}`}>
          <span className={`iconba iconba-${iconClassesVNext}`} />
        </div>
        <div className="summary-header-title">
          <TooltipHost
            overflowMode={TooltipOverflowMode.Parent}
            directionalHint={DirectionalHint.bottomCenter}
            content={title}
          >
            {title}
          </TooltipHost>
        </div>

        {!inContextCard && coupon && <CouponTagNew coupon={coupon} i18n={i18n} />}

        { showAutoApply &&
          <div className="summary-header-auto-apply">
            <TooltipHost
              directionalHint={DirectionalHint.bottomCenter}
              content={autoApplyToolTipText}
              calloutProps={{ calloutMaxWidth: 225 }}
            >
              <Glyphicon glyph="ba-FlashAuto" />
            </TooltipHost>
          </div>
        }

        {type === RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION &&
          <div className="new-badge-container">
            <Badge
              appearance="tint"
            >
              {newI18n.getString(_TL_('New'))}
            </Badge>
          </div>
        }

        {isOptimizationScoreOn && !_.isEmpty(overallOptimizationScoreBar) && !isFromDismissTab &&
          <RecommendationOptimizationScoreTag
            className="summary-card-os-tag"
            i18n={i18n}
            optimizationScore={optimizationScore}
            newI18n={newI18n}
          />
        }

        <div className="summary-header-menu">
          { /* TODO: Check if description should use something different from title */}
          <SummaryContextMenu
            i18n={i18n}
            recommendationDescription={title}
            funcsInMenu={headerMenuItems}
          />
        </div>
      </div>
    );
  }
}
